import { render, staticRenderFns } from "./sidebar-filter.vue?vue&type=template&id=7641601e&scoped=true"
import script from "./sidebar-filter.vue?vue&type=script&lang=js"
export * from "./sidebar-filter.vue?vue&type=script&lang=js"
import style0 from "./sidebar-filter.vue?vue&type=style&index=0&id=7641601e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7641601e",
  null
  
)

export default component.exports